import path from "path";
import {
  AcceptanceFormPage,
  AppAccountPage,
  AppMenuTruongConfig,
  DanThuocPage,
  HocSinhPhuHuynhPage,
  HomePage,
  LoaiGiayTo,
  LopHanhChinhPage,
  QuanHeGiaDinhLayout,
  SendEmailLayout,
  SucKhoeLayout,
  SurveyForm,
  SurveyLayout,
  ThoiKhoaBieuConfigPage,
  ThongTinCbnvPage
} from './pages';
import NguonBietToiPage from "./pages/crm-category/dm_nguonbiettoi";
import NguonBietToiLayout from "./pages/crm-category/NguonBietToiLayout";
import SendNewEmailPage from "./pages/email/send-email/SendNewEmailPage";
import He from "./pages/he";
import HocSinh from "./pages/hoc-sinh";
import Khoi from "./pages/khoi";
import KhoiHePage from "./pages/khoi/khoi_he";
import KyThi from "./pages/ky-thi";
import Lop from "./pages/lop";
import MonThi from "./pages/mon-thi";
import PhuHuynhPage from "./pages/phu-huynh";
import ThangDiem from "./pages/quan-ly-thi/thang-diem";
import FoThucDonLayout from "./pages/thuc-don/FoThucDonLayout";
import Truong from "./pages/truong";
import KyThiMonThi from "./pages/kythi-monthi";
import ThiSinh from "./pages/quan-ly-thi/thi-sinh/ThiSinhPage";
import DanhSachThiPage from "./pages/quan-ly-thi/danh-sach-thi";
import PhongThiPage from "./pages/quan-ly-thi/phong-thi";
import NhapDiemThiPage from "./pages/quan-ly-thi/nhap-diem-thi";
import KetQuaThiPage from "./pages/quan-ly-thi/ket-qua-thi";
import NoiTru from "./pages/noi-tru";
import NoiTruLayout from "./pages/noi-tru/NoiTruLayout";
const routes = [
  {
    path: "/home/:tab?",
    component: HomePage,
  },
  {
    path: "/ds_hoc_sinh_lop/:tab?",
    component: LopHanhChinhPage,
  },
  {
    path: "/app-menu-config/:tab?",
    component: AppMenuTruongConfig,
  },
  {
    path: "/app-account/:tab?", 
    component: AppAccountPage,
  },
  {
    path: "/dan-thuoc/:tab?",
    component: DanThuocPage,
  },
  {
    path: "/crm_survey/form/:id",
    component: SurveyForm,
  },
  {
    path: "/crm_survey/:tab?",
    component: SurveyLayout,
  },
  {
    path: "/thoi-khoa-bieu/:tab?",
    component: ThoiKhoaBieuConfigPage,
  },
  {
    path: "/nguon_biet_toi/:tab?",
    component: NguonBietToiLayout,
  },
  {
    path: "/dm_trangthaihocsinh/:tab?", 
    component: HocSinhPhuHuynhPage,
  },
  {
    path: "/loai_giay_to/:tab?",
    component: LoaiGiayTo,
  },
  {
    path: "/nguon_biet_toi/:tab?",
    component: NguonBietToiPage,
  },
  {
    path: "/send-email/:tab?",
    component: SendEmailLayout,
  },
  // {
  //   path: '/send-email/:id',
  //   component: SendNewEmailPage
  // },
  {
    path: "/hoc-sinh/:tab?",
    component: HocSinh,
  },
  {
    path: "/food/:tab?",
    component: FoThucDonLayout,
  },
  {
    path: "/phu-huynh/:tab?",
    component: PhuHuynhPage,
  },
  {
    path: "/acceptance-form/:tab?",
    component: AcceptanceFormPage,
  },
  {
    path: "/truong/:tab?",
    component: Truong,
  },
  {
    path: "/he/:tab?",
    component: He,
  },
  {
    path: "/khoi/:tab?",
    component: Khoi,
  },
  {
    path: "/khoi_he/:tab?",
    component: KhoiHePage,
  },
  {
    path: "/lop/:tab?",
    component: Lop,
  },
  {
    path: "/suc-khoe/:tab?",
    component: SucKhoeLayout,
  },
  {
    path: "/thang-diem/:tab?",
    component: ThangDiem,
  },
  {
    path: "/mon-thi/:tab?",
    component: MonThi,
  },
  {
    path: '/ky-thi/:tab?',
    component: KyThi
  },
  {
    path: '/thongtin-cbnv/:tab?',
    component: ThongTinCbnvPage,
  },
  {
    path: "kythi-monthi/:tab?",
    component: KyThiMonThi,
  },
  {
    path: "thi-sinh/:tab?",
    component: ThiSinh,
  },
  {
    path: "danh-sach-thi/:tab?",
    component: DanhSachThiPage,
  },
  {
    path: "phong-thi/:tab?",
    component: PhongThiPage,
  },
  {
    path: '/nhap-diem-thi/:tab?',
    component: NhapDiemThiPage
  },
  {
    path: '/ket-qua-thi/:tab?',
    component: KetQuaThiPage
  },
  {
    path: "/noi-tru/:tab?",
    component: NoiTruLayout,
  },
 ];
 
// const routes = [
//   {
//     path: "/home",
//     component: HomePage,
//   },
//   {
//     path: "/ds_hoc_sinh_lop",
//     component: LopHanhChinhPage,
//   },
//   {
//     path: "/app-menu-config",
//     component: AppMenuTruongConfig,
//   },
//   {
//     path: "/app-account",
//     component: AppAccountPage,
//   },
//   {
//     path: "/dan-thuoc",
//     component: DanThuocPage,
//   },
//   {
//     path: "/crm_survey/form/:id",
//     component: SurveyForm,
//   },
//   {
//     path: "/crm_survey/:tab?",
//     component: SurveyLayout,
//   },
//   {
//     path: "/thoi-khoa-bieu",
//     component: ThoiKhoaBieuConfigPage,
//   },
//   {
//     path: "/nguon_biet_toi/:tab?",
//     component: NguonBietToiLayout,
//   },
//   {
//     path: "/dm_trangthaihocsinh/:tab?",
//     component: HocSinhPhuHuynhPage,
//   },
//   {
//     path: "/loai_giay_to",
//     component: LoaiGiayTo,
//   },
//   {
//     path: "/nguon_biet_toi",
//     component: NguonBietToiPage,
//   },
//   {
//     path: "/send-email/:tab?",
//     component: SendEmailLayout,
//   },
//   // {
//   //   path: '/send-email/:id',
//   //   component: SendNewEmailPage
//   // },
//   {
//     path: "/hoc-sinh",
//     component: HocSinh,
//   },
//   {
//     path: "/food/:tab?",
//     component: FoThucDonLayout,
//   },
//   {
//     path: "/phu-huynh",
//     component: PhuHuynhPage,
//   },
//   {
//     path: "/acceptance-form",
//     component: AcceptanceFormPage,
//   },
//   {
//     path: "/truong",
//     component: Truong,
//   },
//   {
//     path: "/he",
//     component: He,
//   },
//   {
//     path: "/khoi",
//     component: Khoi,
//   },
//   {
//     path: "/khoi_he",
//     component: KhoiHePage,
//   },
//   {
//     path: "/lop",
//     component: Lop,
//   },
//   {
//     path: "/suc-khoe/:tab?",
//     component: SucKhoeLayout,
//   },

//   {
//     path: "/thang-diem",
//     component: ThangDiem,
//   },

//   {
//     path: "/mon-thi",
//     component: MonThi,
//   },
//   {
//     path: '/ky-thi',
//     component: KyThi
//   },
//   {
//     path: '/thongtin-cbnv',
//     component: ThongTinCbnvPage,
//   },
//   {
//     path: "kythi-monthi",
//     component: KyThiMonThi,
//   },
//   {
//     path: "thi-sinh",
//     component: ThiSinh,
//   },
//   {
//     path: "danh-sach-thi",
//     component: DanhSachThiPage,
//   },
//   {
//     path: "phong-thi",
//     component: PhongThiPage,
//   },
//   {
//     path: '/nhap-diem-thi',
//     component: NhapDiemThiPage
//   },
//   {
//     path: '/ket-qua-thi',
//     component: KetQuaThiPage
//   },
//   {
//     path: "/noi-tru/:tab?",
//     component: NoiTruLayout,
//   },
// ];
export default routes.map((route) => {
  return {
    ...route,
    // component: withNavigationWatcher(route.component)
  };
});
